//
// 🚨🚨 GENERATED FILE 🚨🚨
//      DO NOT TOUCH
//
// Use "lxo-i18n-extract" to re-generate this file.
//

export const NAMESPACES = [
  "lx-common-error",
  "lxo-blocks-translations",
  "lxo-blocks-translations-common",
];

type ResolveRet =
  | Promise<undefined>
  | Promise<{ default: Record<string, string | null> }>;

export function resolve(locale: string, namespace: string): ResolveRet {
  if (!NAMESPACES.includes(namespace)) {
    return Promise.resolve(undefined);
  }

  if (locale === "de-DE") {
    // @ts-ignore
    return import("./de-de.json");
  }
  if (locale === "de") {
    // @ts-ignore
    return import("./de.json");
  }
  if (locale === "dev") {
    // @ts-ignore
    return import("./dev.json");
  }
  if (locale === "en-GB") {
    // @ts-ignore
    return import("./en-gb.json");
  }
  if (locale === "en") {
    // @ts-ignore
    return import("./en.json");
  }

  return Promise.resolve(undefined);
}
